export default "__VITE_ASSET__Bcr9RcuB__"